import React, { useEffect, useState } from "react";
import { numberFormatWithoutCurrency } from "../../utils/Util.tsx";

// Sample data: each bubble has a label, x/y position, and size
// const bubbleData = [
//   { id: 1, label: "A", x: 50, y: 80, size: 40, color: "#FF6B6B" },
//   { id: 2, label: "B", x: 150, y: 120, size: 60, color: "#4ECDC4" },
//   { id: 3, label: "C", x: 250, y: 60, size: 30, color: "#556270" },
//   { id: 4, label: "D", x: 350, y: 180, size: 50, color: "#C7F464" },
// ];

const BubbleChart = ({ data }) => {
  const [bubbleData, setBubbleData] = useState(null);
  useEffect(() => {
    if (data) {
      setBubbleData(data);
    }
  }, [data]);
  return (
    <>
      {bubbleData?.length && (
        <svg width="400" height="250">
          {bubbleData.map((bubble, index) => (
            <g key={bubble.id}>
              <circle
                cx={bubble.x}
                cy={bubble.y}
                r={bubble.size}
                fill={bubble.color}
                opacity="1"
              />
              <title>{numberFormatWithoutCurrency(bubble?.value)}</title>

              <text
                x={bubble.x}
                y={bubble.y}
                textAnchor="middle"
                dy=".3em"
                fontSize="12"
                fill="#fff"
              >
                {bubble.label}
              </text>
            </g>
          ))}
        </svg>
      )}
    </>
  );
};

export default BubbleChart;
